/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * RapidWorks.UserManagement.WebApi | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminUpdateUserEmailDto,
  CreateUserInput,
  CreateUserResultDto,
  CrossUserDetailDto,
  GetApiUserManagementV1UsersCrossUserIdPermissionsExportParams,
  GetApiUserManagementV1UsersDirectoryBundleParams,
  GetApiUserManagementV1UsersParams,
  GetApiUserManagementV1UsersUsernamePermissionsExportParams,
  MyProfileDto,
  PagedResultOfCrossUserListItemDto,
  ProblemDetails,
  UpdateUserDatabasesInput,
  UpdateUserInput,
  UpdateUserPermissionsInput,
  UpdateUserProfileInput,
  UserApprovalRequestsResultDto,
  UserDto,
  UserPermissionsByDatabaseDto,
  UserStatusActionInput,
  UserStatusResultDto,
  ValidationProblemDetails
} from '../model';

import { axiosInstance } from '../../axios-instance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key]
    });
  }
  return result;
};

export const getApiUserManagementV1UsersDirectoryBundle = (
  params?: GetApiUserManagementV1UsersDirectoryBundleParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/users/directory-bundle`, method: 'GET', params, signal }, options);
};

export const getGetApiUserManagementV1UsersDirectoryBundleQueryKey = (params?: GetApiUserManagementV1UsersDirectoryBundleParams) => {
  return [`/api/user-management/v1/users/directory-bundle`, ...(params ? [params] : [])] as const;
};

export const getGetApiUserManagementV1UsersDirectoryBundleQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersDirectoryBundle>>,
  TError = ProblemDetails
>(
  params?: GetApiUserManagementV1UsersDirectoryBundleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersDirectoryBundle>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1UsersDirectoryBundleQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1UsersDirectoryBundle>>> = ({ signal }) =>
    getApiUserManagementV1UsersDirectoryBundle(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1UsersDirectoryBundle>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1UsersDirectoryBundleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1UsersDirectoryBundle>>
>;
export type GetApiUserManagementV1UsersDirectoryBundleQueryError = ProblemDetails;

export function useGetApiUserManagementV1UsersDirectoryBundle<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersDirectoryBundle>>,
  TError = ProblemDetails
>(
  params: undefined | GetApiUserManagementV1UsersDirectoryBundleParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersDirectoryBundle>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1UsersDirectoryBundle>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1UsersDirectoryBundle>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1UsersDirectoryBundle<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersDirectoryBundle>>,
  TError = ProblemDetails
>(
  params?: GetApiUserManagementV1UsersDirectoryBundleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersDirectoryBundle>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1UsersDirectoryBundle>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1UsersDirectoryBundle>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1UsersDirectoryBundle<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersDirectoryBundle>>,
  TError = ProblemDetails
>(
  params?: GetApiUserManagementV1UsersDirectoryBundleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersDirectoryBundle>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1UsersDirectoryBundle<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersDirectoryBundle>>,
  TError = ProblemDetails
>(
  params?: GetApiUserManagementV1UsersDirectoryBundleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersDirectoryBundle>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1UsersDirectoryBundleQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getApiUserManagementV1Users = (
  params?: GetApiUserManagementV1UsersParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<PagedResultOfCrossUserListItemDto>({ url: `/api/user-management/v1/users`, method: 'GET', params, signal }, options);
};

export const getGetApiUserManagementV1UsersQueryKey = (params?: GetApiUserManagementV1UsersParams) => {
  return [`/api/user-management/v1/users`, ...(params ? [params] : [])] as const;
};

export const getGetApiUserManagementV1UsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1Users>>,
  TError = unknown
>(
  params?: GetApiUserManagementV1UsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Users>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1UsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1Users>>> = ({ signal }) =>
    getApiUserManagementV1Users(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1Users>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1UsersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUserManagementV1Users>>>;
export type GetApiUserManagementV1UsersQueryError = unknown;

export function useGetApiUserManagementV1Users<TData = Awaited<ReturnType<typeof getApiUserManagementV1Users>>, TError = unknown>(
  params: undefined | GetApiUserManagementV1UsersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Users>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1Users>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1Users>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1Users<TData = Awaited<ReturnType<typeof getApiUserManagementV1Users>>, TError = unknown>(
  params?: GetApiUserManagementV1UsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Users>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1Users>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1Users>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1Users<TData = Awaited<ReturnType<typeof getApiUserManagementV1Users>>, TError = unknown>(
  params?: GetApiUserManagementV1UsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Users>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1Users<TData = Awaited<ReturnType<typeof getApiUserManagementV1Users>>, TError = unknown>(
  params?: GetApiUserManagementV1UsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Users>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1UsersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const postApiUserManagementV1Users = (
  createUserInput: CreateUserInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CreateUserResultDto>(
    {
      url: `/api/user-management/v1/users`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createUserInput,
      signal
    },
    options
  );
};

export const getPostApiUserManagementV1UsersMutationOptions = <TError = ProblemDetails, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postApiUserManagementV1Users>>, TError, { data: CreateUserInput }, TContext>;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof postApiUserManagementV1Users>>, TError, { data: CreateUserInput }, TContext> => {
  const mutationKey = ['postApiUserManagementV1Users'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUserManagementV1Users>>, { data: CreateUserInput }> = (props) => {
    const { data } = props ?? {};

    return postApiUserManagementV1Users(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUserManagementV1UsersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUserManagementV1Users>>>;
export type PostApiUserManagementV1UsersMutationBody = CreateUserInput;
export type PostApiUserManagementV1UsersMutationError = ProblemDetails;

export const usePostApiUserManagementV1Users = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof postApiUserManagementV1Users>>, TError, { data: CreateUserInput }, TContext>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof postApiUserManagementV1Users>>, TError, { data: CreateUserInput }, TContext> => {
  return useMutation(getPostApiUserManagementV1UsersMutationOptions(options), queryClient);
};
export const getApiUserManagementV1UsersCrossUserId = (
  crossUserId: string,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<UserDto>({ url: `/api/user-management/v1/users/${crossUserId}`, method: 'GET', signal }, options);
};

export const getGetApiUserManagementV1UsersCrossUserIdQueryKey = (crossUserId: string) => {
  return [`/api/user-management/v1/users/${crossUserId}`] as const;
};

export const getGetApiUserManagementV1UsersCrossUserIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserId>>,
  TError = ProblemDetails
>(
  crossUserId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1UsersCrossUserIdQueryKey(crossUserId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserId>>> = ({ signal }) =>
    getApiUserManagementV1UsersCrossUserId(crossUserId, requestOptions, signal);

  return { queryKey, queryFn, enabled: crossUserId !== null && crossUserId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1UsersCrossUserIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserId>>
>;
export type GetApiUserManagementV1UsersCrossUserIdQueryError = ProblemDetails;

export function useGetApiUserManagementV1UsersCrossUserId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserId>>,
  TError = ProblemDetails
>(
  crossUserId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserId>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1UsersCrossUserId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserId>>,
  TError = ProblemDetails
>(
  crossUserId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserId>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1UsersCrossUserId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserId>>,
  TError = ProblemDetails
>(
  crossUserId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1UsersCrossUserId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserId>>,
  TError = ProblemDetails
>(
  crossUserId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1UsersCrossUserIdQueryOptions(crossUserId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const putApiUserManagementV1UsersCrossUserId = (
  crossUserId: string,
  updateUserInput: UpdateUserInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<UserDto>(
    {
      url: `/api/user-management/v1/users/${crossUserId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateUserInput,
      signal
    },
    options
  );
};

export const getPutApiUserManagementV1UsersCrossUserIdMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserId>>,
    TError,
    { crossUserId: string; data: UpdateUserInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserId>>,
  TError,
  { crossUserId: string; data: UpdateUserInput },
  TContext
> => {
  const mutationKey = ['putApiUserManagementV1UsersCrossUserId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserId>>,
    { crossUserId: string; data: UpdateUserInput }
  > = (props) => {
    const { crossUserId, data } = props ?? {};

    return putApiUserManagementV1UsersCrossUserId(crossUserId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiUserManagementV1UsersCrossUserIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserId>>
>;
export type PutApiUserManagementV1UsersCrossUserIdMutationBody = UpdateUserInput;
export type PutApiUserManagementV1UsersCrossUserIdMutationError = unknown;

export const usePutApiUserManagementV1UsersCrossUserId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserId>>,
      TError,
      { crossUserId: string; data: UpdateUserInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserId>>,
  TError,
  { crossUserId: string; data: UpdateUserInput },
  TContext
> => {
  return useMutation(getPutApiUserManagementV1UsersCrossUserIdMutationOptions(options), queryClient);
};
export const getApiUserManagementV1UsersNumericUserKey = (
  numericUserKey: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CrossUserDetailDto>({ url: `/api/user-management/v1/users/${numericUserKey}`, method: 'GET', signal }, options);
};

export const getGetApiUserManagementV1UsersNumericUserKeyQueryKey = (numericUserKey: number) => {
  return [`/api/user-management/v1/users/${numericUserKey}`] as const;
};

export const getGetApiUserManagementV1UsersNumericUserKeyQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersNumericUserKey>>,
  TError = ProblemDetails
>(
  numericUserKey: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersNumericUserKey>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1UsersNumericUserKeyQueryKey(numericUserKey);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1UsersNumericUserKey>>> = ({ signal }) =>
    getApiUserManagementV1UsersNumericUserKey(numericUserKey, requestOptions, signal);

  return { queryKey, queryFn, enabled: numericUserKey !== null && numericUserKey !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1UsersNumericUserKey>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1UsersNumericUserKeyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1UsersNumericUserKey>>
>;
export type GetApiUserManagementV1UsersNumericUserKeyQueryError = ProblemDetails;

export function useGetApiUserManagementV1UsersNumericUserKey<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersNumericUserKey>>,
  TError = ProblemDetails
>(
  numericUserKey: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersNumericUserKey>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1UsersNumericUserKey>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1UsersNumericUserKey>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1UsersNumericUserKey<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersNumericUserKey>>,
  TError = ProblemDetails
>(
  numericUserKey: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersNumericUserKey>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1UsersNumericUserKey>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1UsersNumericUserKey>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1UsersNumericUserKey<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersNumericUserKey>>,
  TError = ProblemDetails
>(
  numericUserKey: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersNumericUserKey>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1UsersNumericUserKey<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersNumericUserKey>>,
  TError = ProblemDetails
>(
  numericUserKey: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersNumericUserKey>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1UsersNumericUserKeyQueryOptions(numericUserKey, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getApiUserManagementV1UsersUsername = (
  username: string,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CrossUserDetailDto>({ url: `/api/user-management/v1/users/${username}`, method: 'GET', signal }, options);
};

export const getGetApiUserManagementV1UsersUsernameQueryKey = (username: string) => {
  return [`/api/user-management/v1/users/${username}`] as const;
};

export const getGetApiUserManagementV1UsersUsernameQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersUsername>>,
  TError = ProblemDetails
>(
  username: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsername>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1UsersUsernameQueryKey(username);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsername>>> = ({ signal }) =>
    getApiUserManagementV1UsersUsername(username, requestOptions, signal);

  return { queryKey, queryFn, enabled: username !== null && username !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1UsersUsername>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1UsersUsernameQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsername>>>;
export type GetApiUserManagementV1UsersUsernameQueryError = ProblemDetails;

export function useGetApiUserManagementV1UsersUsername<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersUsername>>,
  TError = ProblemDetails
>(
  username: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsername>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1UsersUsername>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1UsersUsername>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1UsersUsername<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersUsername>>,
  TError = ProblemDetails
>(
  username: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsername>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1UsersUsername>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1UsersUsername>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1UsersUsername<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersUsername>>,
  TError = ProblemDetails
>(
  username: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsername>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1UsersUsername<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersUsername>>,
  TError = ProblemDetails
>(
  username: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsername>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1UsersUsernameQueryOptions(username, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getApiUserManagementV1UsersUsernamePermissions = (
  username: string,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<UserPermissionsByDatabaseDto>(
    { url: `/api/user-management/v1/users/${username}/permissions`, method: 'GET', signal },
    options
  );
};

export const getGetApiUserManagementV1UsersUsernamePermissionsQueryKey = (username: string) => {
  return [`/api/user-management/v1/users/${username}/permissions`] as const;
};

export const getGetApiUserManagementV1UsersUsernamePermissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissions>>,
  TError = ProblemDetails
>(
  username: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissions>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1UsersUsernamePermissionsQueryKey(username);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissions>>> = ({ signal }) =>
    getApiUserManagementV1UsersUsernamePermissions(username, requestOptions, signal);

  return { queryKey, queryFn, enabled: username !== null && username !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1UsersUsernamePermissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissions>>
>;
export type GetApiUserManagementV1UsersUsernamePermissionsQueryError = ProblemDetails;

export function useGetApiUserManagementV1UsersUsernamePermissions<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissions>>,
  TError = ProblemDetails
>(
  username: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissions>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1UsersUsernamePermissions<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissions>>,
  TError = ProblemDetails
>(
  username: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissions>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1UsersUsernamePermissions<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissions>>,
  TError = ProblemDetails
>(
  username: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissions>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1UsersUsernamePermissions<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissions>>,
  TError = ProblemDetails
>(
  username: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissions>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1UsersUsernamePermissionsQueryOptions(username, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getApiUserManagementV1UsersUsernamePermissionsExport = (
  username: string,
  params?: GetApiUserManagementV1UsersUsernamePermissionsExportParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/user-management/v1/users/${username}/permissions/export`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiUserManagementV1UsersUsernamePermissionsExportQueryKey = (
  username: string,
  params?: GetApiUserManagementV1UsersUsernamePermissionsExportParams
) => {
  return [`/api/user-management/v1/users/${username}/permissions/export`, ...(params ? [params] : [])] as const;
};

export const getGetApiUserManagementV1UsersUsernamePermissionsExportQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissionsExport>>,
  TError = unknown
>(
  username: string,
  params?: GetApiUserManagementV1UsersUsernamePermissionsExportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissionsExport>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1UsersUsernamePermissionsExportQueryKey(username, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissionsExport>>> = ({ signal }) =>
    getApiUserManagementV1UsersUsernamePermissionsExport(username, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: username !== null && username !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissionsExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1UsersUsernamePermissionsExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissionsExport>>
>;
export type GetApiUserManagementV1UsersUsernamePermissionsExportQueryError = unknown;

export function useGetApiUserManagementV1UsersUsernamePermissionsExport<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissionsExport>>,
  TError = unknown
>(
  username: string,
  params: undefined | GetApiUserManagementV1UsersUsernamePermissionsExportParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissionsExport>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissionsExport>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissionsExport>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1UsersUsernamePermissionsExport<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissionsExport>>,
  TError = unknown
>(
  username: string,
  params?: GetApiUserManagementV1UsersUsernamePermissionsExportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissionsExport>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissionsExport>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissionsExport>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1UsersUsernamePermissionsExport<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissionsExport>>,
  TError = unknown
>(
  username: string,
  params?: GetApiUserManagementV1UsersUsernamePermissionsExportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissionsExport>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1UsersUsernamePermissionsExport<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissionsExport>>,
  TError = unknown
>(
  username: string,
  params?: GetApiUserManagementV1UsersUsernamePermissionsExportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernamePermissionsExport>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1UsersUsernamePermissionsExportQueryOptions(username, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getApiUserManagementV1UsersUsernameApprovalRequests = (
  username: string,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<UserApprovalRequestsResultDto>(
    { url: `/api/user-management/v1/users/${username}/approval-requests`, method: 'GET', signal },
    options
  );
};

export const getGetApiUserManagementV1UsersUsernameApprovalRequestsQueryKey = (username: string) => {
  return [`/api/user-management/v1/users/${username}/approval-requests`] as const;
};

export const getGetApiUserManagementV1UsersUsernameApprovalRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernameApprovalRequests>>,
  TError = ProblemDetails
>(
  username: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernameApprovalRequests>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1UsersUsernameApprovalRequestsQueryKey(username);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernameApprovalRequests>>> = ({ signal }) =>
    getApiUserManagementV1UsersUsernameApprovalRequests(username, requestOptions, signal);

  return { queryKey, queryFn, enabled: username !== null && username !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernameApprovalRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1UsersUsernameApprovalRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernameApprovalRequests>>
>;
export type GetApiUserManagementV1UsersUsernameApprovalRequestsQueryError = ProblemDetails;

export function useGetApiUserManagementV1UsersUsernameApprovalRequests<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernameApprovalRequests>>,
  TError = ProblemDetails
>(
  username: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernameApprovalRequests>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernameApprovalRequests>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernameApprovalRequests>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1UsersUsernameApprovalRequests<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernameApprovalRequests>>,
  TError = ProblemDetails
>(
  username: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernameApprovalRequests>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernameApprovalRequests>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernameApprovalRequests>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1UsersUsernameApprovalRequests<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernameApprovalRequests>>,
  TError = ProblemDetails
>(
  username: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernameApprovalRequests>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1UsersUsernameApprovalRequests<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernameApprovalRequests>>,
  TError = ProblemDetails
>(
  username: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersUsernameApprovalRequests>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1UsersUsernameApprovalRequestsQueryOptions(username, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const putApiUserManagementV1UsersCrossUserIdProfile = (
  crossUserId: string,
  updateUserProfileInput: UpdateUserProfileInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<UserDto>(
    {
      url: `/api/user-management/v1/users/${crossUserId}/profile`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateUserProfileInput,
      signal
    },
    options
  );
};

export const getPutApiUserManagementV1UsersCrossUserIdProfileMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdProfile>>,
    TError,
    { crossUserId: string; data: UpdateUserProfileInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdProfile>>,
  TError,
  { crossUserId: string; data: UpdateUserProfileInput },
  TContext
> => {
  const mutationKey = ['putApiUserManagementV1UsersCrossUserIdProfile'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdProfile>>,
    { crossUserId: string; data: UpdateUserProfileInput }
  > = (props) => {
    const { crossUserId, data } = props ?? {};

    return putApiUserManagementV1UsersCrossUserIdProfile(crossUserId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiUserManagementV1UsersCrossUserIdProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdProfile>>
>;
export type PutApiUserManagementV1UsersCrossUserIdProfileMutationBody = UpdateUserProfileInput;
export type PutApiUserManagementV1UsersCrossUserIdProfileMutationError = unknown;

export const usePutApiUserManagementV1UsersCrossUserIdProfile = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdProfile>>,
      TError,
      { crossUserId: string; data: UpdateUserProfileInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdProfile>>,
  TError,
  { crossUserId: string; data: UpdateUserProfileInput },
  TContext
> => {
  return useMutation(getPutApiUserManagementV1UsersCrossUserIdProfileMutationOptions(options), queryClient);
};
export const patchApiUserManagementV1UsersCrossUserIdDeactivate = (
  crossUserId: string,
  userStatusActionInput: UserStatusActionInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<UserStatusResultDto>(
    {
      url: `/api/user-management/v1/users/${crossUserId}/deactivate`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: userStatusActionInput,
      signal
    },
    options
  );
};

export const getPatchApiUserManagementV1UsersCrossUserIdDeactivateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchApiUserManagementV1UsersCrossUserIdDeactivate>>,
    TError,
    { crossUserId: string; data: UserStatusActionInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchApiUserManagementV1UsersCrossUserIdDeactivate>>,
  TError,
  { crossUserId: string; data: UserStatusActionInput },
  TContext
> => {
  const mutationKey = ['patchApiUserManagementV1UsersCrossUserIdDeactivate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchApiUserManagementV1UsersCrossUserIdDeactivate>>,
    { crossUserId: string; data: UserStatusActionInput }
  > = (props) => {
    const { crossUserId, data } = props ?? {};

    return patchApiUserManagementV1UsersCrossUserIdDeactivate(crossUserId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchApiUserManagementV1UsersCrossUserIdDeactivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchApiUserManagementV1UsersCrossUserIdDeactivate>>
>;
export type PatchApiUserManagementV1UsersCrossUserIdDeactivateMutationBody = UserStatusActionInput;
export type PatchApiUserManagementV1UsersCrossUserIdDeactivateMutationError = unknown;

export const usePatchApiUserManagementV1UsersCrossUserIdDeactivate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchApiUserManagementV1UsersCrossUserIdDeactivate>>,
      TError,
      { crossUserId: string; data: UserStatusActionInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchApiUserManagementV1UsersCrossUserIdDeactivate>>,
  TError,
  { crossUserId: string; data: UserStatusActionInput },
  TContext
> => {
  return useMutation(getPatchApiUserManagementV1UsersCrossUserIdDeactivateMutationOptions(options), queryClient);
};
export const patchApiUserManagementV1UsersCrossUserIdReactivate = (
  crossUserId: string,
  userStatusActionInput: UserStatusActionInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<UserStatusResultDto>(
    {
      url: `/api/user-management/v1/users/${crossUserId}/reactivate`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: userStatusActionInput,
      signal
    },
    options
  );
};

export const getPatchApiUserManagementV1UsersCrossUserIdReactivateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchApiUserManagementV1UsersCrossUserIdReactivate>>,
    TError,
    { crossUserId: string; data: UserStatusActionInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchApiUserManagementV1UsersCrossUserIdReactivate>>,
  TError,
  { crossUserId: string; data: UserStatusActionInput },
  TContext
> => {
  const mutationKey = ['patchApiUserManagementV1UsersCrossUserIdReactivate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchApiUserManagementV1UsersCrossUserIdReactivate>>,
    { crossUserId: string; data: UserStatusActionInput }
  > = (props) => {
    const { crossUserId, data } = props ?? {};

    return patchApiUserManagementV1UsersCrossUserIdReactivate(crossUserId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchApiUserManagementV1UsersCrossUserIdReactivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchApiUserManagementV1UsersCrossUserIdReactivate>>
>;
export type PatchApiUserManagementV1UsersCrossUserIdReactivateMutationBody = UserStatusActionInput;
export type PatchApiUserManagementV1UsersCrossUserIdReactivateMutationError = unknown;

export const usePatchApiUserManagementV1UsersCrossUserIdReactivate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchApiUserManagementV1UsersCrossUserIdReactivate>>,
      TError,
      { crossUserId: string; data: UserStatusActionInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchApiUserManagementV1UsersCrossUserIdReactivate>>,
  TError,
  { crossUserId: string; data: UserStatusActionInput },
  TContext
> => {
  return useMutation(getPatchApiUserManagementV1UsersCrossUserIdReactivateMutationOptions(options), queryClient);
};
export const getApiUserManagementV1UsersCrossUserIdPermissions = (
  crossUserId: string,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/users/${crossUserId}/permissions`, method: 'GET', signal }, options);
};

export const getGetApiUserManagementV1UsersCrossUserIdPermissionsQueryKey = (crossUserId: string) => {
  return [`/api/user-management/v1/users/${crossUserId}/permissions`] as const;
};

export const getGetApiUserManagementV1UsersCrossUserIdPermissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissions>>,
  TError = unknown
>(
  crossUserId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissions>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1UsersCrossUserIdPermissionsQueryKey(crossUserId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissions>>> = ({ signal }) =>
    getApiUserManagementV1UsersCrossUserIdPermissions(crossUserId, requestOptions, signal);

  return { queryKey, queryFn, enabled: crossUserId !== null && crossUserId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1UsersCrossUserIdPermissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissions>>
>;
export type GetApiUserManagementV1UsersCrossUserIdPermissionsQueryError = unknown;

export function useGetApiUserManagementV1UsersCrossUserIdPermissions<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissions>>,
  TError = unknown
>(
  crossUserId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissions>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1UsersCrossUserIdPermissions<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissions>>,
  TError = unknown
>(
  crossUserId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissions>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1UsersCrossUserIdPermissions<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissions>>,
  TError = unknown
>(
  crossUserId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissions>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1UsersCrossUserIdPermissions<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissions>>,
  TError = unknown
>(
  crossUserId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissions>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1UsersCrossUserIdPermissionsQueryOptions(crossUserId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const putApiUserManagementV1UsersCrossUserIdPermissions = (
  crossUserId: string,
  updateUserPermissionsInput: UpdateUserPermissionsInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/user-management/v1/users/${crossUserId}/permissions`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateUserPermissionsInput,
      signal
    },
    options
  );
};

export const getPutApiUserManagementV1UsersCrossUserIdPermissionsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdPermissions>>,
    TError,
    { crossUserId: string; data: UpdateUserPermissionsInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdPermissions>>,
  TError,
  { crossUserId: string; data: UpdateUserPermissionsInput },
  TContext
> => {
  const mutationKey = ['putApiUserManagementV1UsersCrossUserIdPermissions'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdPermissions>>,
    { crossUserId: string; data: UpdateUserPermissionsInput }
  > = (props) => {
    const { crossUserId, data } = props ?? {};

    return putApiUserManagementV1UsersCrossUserIdPermissions(crossUserId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiUserManagementV1UsersCrossUserIdPermissionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdPermissions>>
>;
export type PutApiUserManagementV1UsersCrossUserIdPermissionsMutationBody = UpdateUserPermissionsInput;
export type PutApiUserManagementV1UsersCrossUserIdPermissionsMutationError = unknown;

export const usePutApiUserManagementV1UsersCrossUserIdPermissions = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdPermissions>>,
      TError,
      { crossUserId: string; data: UpdateUserPermissionsInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdPermissions>>,
  TError,
  { crossUserId: string; data: UpdateUserPermissionsInput },
  TContext
> => {
  return useMutation(getPutApiUserManagementV1UsersCrossUserIdPermissionsMutationOptions(options), queryClient);
};
export const getApiUserManagementV1UsersCrossUserIdPermissionsExport = (
  crossUserId: string,
  params?: GetApiUserManagementV1UsersCrossUserIdPermissionsExportParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    { url: `/api/user-management/v1/users/${crossUserId}/permissions/export`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiUserManagementV1UsersCrossUserIdPermissionsExportQueryKey = (
  crossUserId: string,
  params?: GetApiUserManagementV1UsersCrossUserIdPermissionsExportParams
) => {
  return [`/api/user-management/v1/users/${crossUserId}/permissions/export`, ...(params ? [params] : [])] as const;
};

export const getGetApiUserManagementV1UsersCrossUserIdPermissionsExportQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissionsExport>>,
  TError = unknown
>(
  crossUserId: string,
  params?: GetApiUserManagementV1UsersCrossUserIdPermissionsExportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissionsExport>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1UsersCrossUserIdPermissionsExportQueryKey(crossUserId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissionsExport>>> = ({ signal }) =>
    getApiUserManagementV1UsersCrossUserIdPermissionsExport(crossUserId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: crossUserId !== null && crossUserId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissionsExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1UsersCrossUserIdPermissionsExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissionsExport>>
>;
export type GetApiUserManagementV1UsersCrossUserIdPermissionsExportQueryError = unknown;

export function useGetApiUserManagementV1UsersCrossUserIdPermissionsExport<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissionsExport>>,
  TError = unknown
>(
  crossUserId: string,
  params: undefined | GetApiUserManagementV1UsersCrossUserIdPermissionsExportParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissionsExport>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissionsExport>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissionsExport>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1UsersCrossUserIdPermissionsExport<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissionsExport>>,
  TError = unknown
>(
  crossUserId: string,
  params?: GetApiUserManagementV1UsersCrossUserIdPermissionsExportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissionsExport>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissionsExport>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissionsExport>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1UsersCrossUserIdPermissionsExport<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissionsExport>>,
  TError = unknown
>(
  crossUserId: string,
  params?: GetApiUserManagementV1UsersCrossUserIdPermissionsExportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissionsExport>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1UsersCrossUserIdPermissionsExport<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissionsExport>>,
  TError = unknown
>(
  crossUserId: string,
  params?: GetApiUserManagementV1UsersCrossUserIdPermissionsExportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdPermissionsExport>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1UsersCrossUserIdPermissionsExportQueryOptions(crossUserId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getApiUserManagementV1UsersCrossUserIdDatabases = (
  crossUserId: string,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/users/${crossUserId}/databases`, method: 'GET', signal }, options);
};

export const getGetApiUserManagementV1UsersCrossUserIdDatabasesQueryKey = (crossUserId: string) => {
  return [`/api/user-management/v1/users/${crossUserId}/databases`] as const;
};

export const getGetApiUserManagementV1UsersCrossUserIdDatabasesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdDatabases>>,
  TError = unknown
>(
  crossUserId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdDatabases>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1UsersCrossUserIdDatabasesQueryKey(crossUserId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdDatabases>>> = ({ signal }) =>
    getApiUserManagementV1UsersCrossUserIdDatabases(crossUserId, requestOptions, signal);

  return { queryKey, queryFn, enabled: crossUserId !== null && crossUserId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdDatabases>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1UsersCrossUserIdDatabasesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdDatabases>>
>;
export type GetApiUserManagementV1UsersCrossUserIdDatabasesQueryError = unknown;

export function useGetApiUserManagementV1UsersCrossUserIdDatabases<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdDatabases>>,
  TError = unknown
>(
  crossUserId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdDatabases>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdDatabases>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdDatabases>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1UsersCrossUserIdDatabases<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdDatabases>>,
  TError = unknown
>(
  crossUserId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdDatabases>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdDatabases>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdDatabases>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1UsersCrossUserIdDatabases<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdDatabases>>,
  TError = unknown
>(
  crossUserId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdDatabases>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1UsersCrossUserIdDatabases<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdDatabases>>,
  TError = unknown
>(
  crossUserId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersCrossUserIdDatabases>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1UsersCrossUserIdDatabasesQueryOptions(crossUserId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const putApiUserManagementV1UsersCrossUserIdDatabases = (
  crossUserId: string,
  updateUserDatabasesInput: UpdateUserDatabasesInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/user-management/v1/users/${crossUserId}/databases`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateUserDatabasesInput,
      signal
    },
    options
  );
};

export const getPutApiUserManagementV1UsersCrossUserIdDatabasesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdDatabases>>,
    TError,
    { crossUserId: string; data: UpdateUserDatabasesInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdDatabases>>,
  TError,
  { crossUserId: string; data: UpdateUserDatabasesInput },
  TContext
> => {
  const mutationKey = ['putApiUserManagementV1UsersCrossUserIdDatabases'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdDatabases>>,
    { crossUserId: string; data: UpdateUserDatabasesInput }
  > = (props) => {
    const { crossUserId, data } = props ?? {};

    return putApiUserManagementV1UsersCrossUserIdDatabases(crossUserId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiUserManagementV1UsersCrossUserIdDatabasesMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdDatabases>>
>;
export type PutApiUserManagementV1UsersCrossUserIdDatabasesMutationBody = UpdateUserDatabasesInput;
export type PutApiUserManagementV1UsersCrossUserIdDatabasesMutationError = unknown;

export const usePutApiUserManagementV1UsersCrossUserIdDatabases = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdDatabases>>,
      TError,
      { crossUserId: string; data: UpdateUserDatabasesInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdDatabases>>,
  TError,
  { crossUserId: string; data: UpdateUserDatabasesInput },
  TContext
> => {
  return useMutation(getPutApiUserManagementV1UsersCrossUserIdDatabasesMutationOptions(options), queryClient);
};
export const postApiUserManagementV1UsersCrossUserIdLock = (
  crossUserId: string,
  userStatusActionInput: UserStatusActionInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/user-management/v1/users/${crossUserId}/lock`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: userStatusActionInput,
      signal
    },
    options
  );
};

export const getPostApiUserManagementV1UsersCrossUserIdLockMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdLock>>,
    TError,
    { crossUserId: string; data: UserStatusActionInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdLock>>,
  TError,
  { crossUserId: string; data: UserStatusActionInput },
  TContext
> => {
  const mutationKey = ['postApiUserManagementV1UsersCrossUserIdLock'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdLock>>,
    { crossUserId: string; data: UserStatusActionInput }
  > = (props) => {
    const { crossUserId, data } = props ?? {};

    return postApiUserManagementV1UsersCrossUserIdLock(crossUserId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUserManagementV1UsersCrossUserIdLockMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdLock>>
>;
export type PostApiUserManagementV1UsersCrossUserIdLockMutationBody = UserStatusActionInput;
export type PostApiUserManagementV1UsersCrossUserIdLockMutationError = unknown;

export const usePostApiUserManagementV1UsersCrossUserIdLock = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdLock>>,
      TError,
      { crossUserId: string; data: UserStatusActionInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdLock>>,
  TError,
  { crossUserId: string; data: UserStatusActionInput },
  TContext
> => {
  return useMutation(getPostApiUserManagementV1UsersCrossUserIdLockMutationOptions(options), queryClient);
};
export const postApiUserManagementV1UsersCrossUserIdUnlock = (
  crossUserId: string,
  userStatusActionInput: UserStatusActionInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/user-management/v1/users/${crossUserId}/unlock`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: userStatusActionInput,
      signal
    },
    options
  );
};

export const getPostApiUserManagementV1UsersCrossUserIdUnlockMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdUnlock>>,
    TError,
    { crossUserId: string; data: UserStatusActionInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdUnlock>>,
  TError,
  { crossUserId: string; data: UserStatusActionInput },
  TContext
> => {
  const mutationKey = ['postApiUserManagementV1UsersCrossUserIdUnlock'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdUnlock>>,
    { crossUserId: string; data: UserStatusActionInput }
  > = (props) => {
    const { crossUserId, data } = props ?? {};

    return postApiUserManagementV1UsersCrossUserIdUnlock(crossUserId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUserManagementV1UsersCrossUserIdUnlockMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdUnlock>>
>;
export type PostApiUserManagementV1UsersCrossUserIdUnlockMutationBody = UserStatusActionInput;
export type PostApiUserManagementV1UsersCrossUserIdUnlockMutationError = unknown;

export const usePostApiUserManagementV1UsersCrossUserIdUnlock = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdUnlock>>,
      TError,
      { crossUserId: string; data: UserStatusActionInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdUnlock>>,
  TError,
  { crossUserId: string; data: UserStatusActionInput },
  TContext
> => {
  return useMutation(getPostApiUserManagementV1UsersCrossUserIdUnlockMutationOptions(options), queryClient);
};
export const postApiUserManagementV1UsersCrossUserIdSuspend = (
  crossUserId: string,
  userStatusActionInput: UserStatusActionInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/user-management/v1/users/${crossUserId}/suspend`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: userStatusActionInput,
      signal
    },
    options
  );
};

export const getPostApiUserManagementV1UsersCrossUserIdSuspendMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdSuspend>>,
    TError,
    { crossUserId: string; data: UserStatusActionInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdSuspend>>,
  TError,
  { crossUserId: string; data: UserStatusActionInput },
  TContext
> => {
  const mutationKey = ['postApiUserManagementV1UsersCrossUserIdSuspend'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdSuspend>>,
    { crossUserId: string; data: UserStatusActionInput }
  > = (props) => {
    const { crossUserId, data } = props ?? {};

    return postApiUserManagementV1UsersCrossUserIdSuspend(crossUserId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUserManagementV1UsersCrossUserIdSuspendMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdSuspend>>
>;
export type PostApiUserManagementV1UsersCrossUserIdSuspendMutationBody = UserStatusActionInput;
export type PostApiUserManagementV1UsersCrossUserIdSuspendMutationError = unknown;

export const usePostApiUserManagementV1UsersCrossUserIdSuspend = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdSuspend>>,
      TError,
      { crossUserId: string; data: UserStatusActionInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdSuspend>>,
  TError,
  { crossUserId: string; data: UserStatusActionInput },
  TContext
> => {
  return useMutation(getPostApiUserManagementV1UsersCrossUserIdSuspendMutationOptions(options), queryClient);
};
export const postApiUserManagementV1UsersCrossUserIdUnsuspend = (
  crossUserId: string,
  userStatusActionInput: UserStatusActionInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/user-management/v1/users/${crossUserId}/unsuspend`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: userStatusActionInput,
      signal
    },
    options
  );
};

export const getPostApiUserManagementV1UsersCrossUserIdUnsuspendMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdUnsuspend>>,
    TError,
    { crossUserId: string; data: UserStatusActionInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdUnsuspend>>,
  TError,
  { crossUserId: string; data: UserStatusActionInput },
  TContext
> => {
  const mutationKey = ['postApiUserManagementV1UsersCrossUserIdUnsuspend'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdUnsuspend>>,
    { crossUserId: string; data: UserStatusActionInput }
  > = (props) => {
    const { crossUserId, data } = props ?? {};

    return postApiUserManagementV1UsersCrossUserIdUnsuspend(crossUserId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUserManagementV1UsersCrossUserIdUnsuspendMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdUnsuspend>>
>;
export type PostApiUserManagementV1UsersCrossUserIdUnsuspendMutationBody = UserStatusActionInput;
export type PostApiUserManagementV1UsersCrossUserIdUnsuspendMutationError = unknown;

export const usePostApiUserManagementV1UsersCrossUserIdUnsuspend = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdUnsuspend>>,
      TError,
      { crossUserId: string; data: UserStatusActionInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdUnsuspend>>,
  TError,
  { crossUserId: string; data: UserStatusActionInput },
  TContext
> => {
  return useMutation(getPostApiUserManagementV1UsersCrossUserIdUnsuspendMutationOptions(options), queryClient);
};
export const postApiUserManagementV1UsersCrossUserIdForcePasswordReset = (
  crossUserId: string,
  userStatusActionInput: UserStatusActionInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>(
    {
      url: `/api/user-management/v1/users/${crossUserId}/force-password-reset`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: userStatusActionInput,
      signal
    },
    options
  );
};

export const getPostApiUserManagementV1UsersCrossUserIdForcePasswordResetMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdForcePasswordReset>>,
    TError,
    { crossUserId: string; data: UserStatusActionInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdForcePasswordReset>>,
  TError,
  { crossUserId: string; data: UserStatusActionInput },
  TContext
> => {
  const mutationKey = ['postApiUserManagementV1UsersCrossUserIdForcePasswordReset'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdForcePasswordReset>>,
    { crossUserId: string; data: UserStatusActionInput }
  > = (props) => {
    const { crossUserId, data } = props ?? {};

    return postApiUserManagementV1UsersCrossUserIdForcePasswordReset(crossUserId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUserManagementV1UsersCrossUserIdForcePasswordResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdForcePasswordReset>>
>;
export type PostApiUserManagementV1UsersCrossUserIdForcePasswordResetMutationBody = UserStatusActionInput;
export type PostApiUserManagementV1UsersCrossUserIdForcePasswordResetMutationError = unknown;

export const usePostApiUserManagementV1UsersCrossUserIdForcePasswordReset = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdForcePasswordReset>>,
      TError,
      { crossUserId: string; data: UserStatusActionInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdForcePasswordReset>>,
  TError,
  { crossUserId: string; data: UserStatusActionInput },
  TContext
> => {
  return useMutation(getPostApiUserManagementV1UsersCrossUserIdForcePasswordResetMutationOptions(options), queryClient);
};
export const putApiUserManagementV1UsersCrossUserIdEmail = (
  crossUserId: string,
  adminUpdateUserEmailDto: AdminUpdateUserEmailDto,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<MyProfileDto>(
    {
      url: `/api/user-management/v1/users/${crossUserId}/email`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: adminUpdateUserEmailDto,
      signal
    },
    options
  );
};

export const getPutApiUserManagementV1UsersCrossUserIdEmailMutationOptions = <
  TError = ValidationProblemDetails | ProblemDetails,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdEmail>>,
    TError,
    { crossUserId: string; data: AdminUpdateUserEmailDto },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdEmail>>,
  TError,
  { crossUserId: string; data: AdminUpdateUserEmailDto },
  TContext
> => {
  const mutationKey = ['putApiUserManagementV1UsersCrossUserIdEmail'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdEmail>>,
    { crossUserId: string; data: AdminUpdateUserEmailDto }
  > = (props) => {
    const { crossUserId, data } = props ?? {};

    return putApiUserManagementV1UsersCrossUserIdEmail(crossUserId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiUserManagementV1UsersCrossUserIdEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdEmail>>
>;
export type PutApiUserManagementV1UsersCrossUserIdEmailMutationBody = AdminUpdateUserEmailDto;
export type PutApiUserManagementV1UsersCrossUserIdEmailMutationError = ValidationProblemDetails | ProblemDetails;

export const usePutApiUserManagementV1UsersCrossUserIdEmail = <TError = ValidationProblemDetails | ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdEmail>>,
      TError,
      { crossUserId: string; data: AdminUpdateUserEmailDto },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiUserManagementV1UsersCrossUserIdEmail>>,
  TError,
  { crossUserId: string; data: AdminUpdateUserEmailDto },
  TContext
> => {
  return useMutation(getPutApiUserManagementV1UsersCrossUserIdEmailMutationOptions(options), queryClient);
};
export const postApiUserManagementV1UsersCrossUserIdSendPasswordReset = (
  crossUserId: string,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<void>({ url: `/api/user-management/v1/users/${crossUserId}/send-password-reset`, method: 'POST', signal }, options);
};

export const getPostApiUserManagementV1UsersCrossUserIdSendPasswordResetMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdSendPasswordReset>>,
    TError,
    { crossUserId: string },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdSendPasswordReset>>,
  TError,
  { crossUserId: string },
  TContext
> => {
  const mutationKey = ['postApiUserManagementV1UsersCrossUserIdSendPasswordReset'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdSendPasswordReset>>,
    { crossUserId: string }
  > = (props) => {
    const { crossUserId } = props ?? {};

    return postApiUserManagementV1UsersCrossUserIdSendPasswordReset(crossUserId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUserManagementV1UsersCrossUserIdSendPasswordResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdSendPasswordReset>>
>;

export type PostApiUserManagementV1UsersCrossUserIdSendPasswordResetMutationError = ProblemDetails;

export const usePostApiUserManagementV1UsersCrossUserIdSendPasswordReset = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdSendPasswordReset>>,
      TError,
      { crossUserId: string },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUserManagementV1UsersCrossUserIdSendPasswordReset>>,
  TError,
  { crossUserId: string },
  TContext
> => {
  return useMutation(getPostApiUserManagementV1UsersCrossUserIdSendPasswordResetMutationOptions(options), queryClient);
};
